import { fmt } from '../../utils/formatters';

export default function InvoiceTotalsEditable({ subtotal, vatAmount, grandTotal, delivery, onDeliveryChange }) {
  return (
    <div className="totals-section">
      <div className="totals-box">
        <div className="total-row"><span className="total-label">Subtotal</span><span className="total-val">{fmt(subtotal)}</span></div>
        <div className="total-row"><span className="total-label">VAT</span><span className="total-val">{fmt(vatAmount)}</span></div>
        <div className="total-row">
          <span className="total-label">Delivery</span>
          <input
            type="number" min="0" step="0.01"
            className="delivery-input"
            value={delivery}
            onChange={e => onDeliveryChange(e.target.value)}
          />
        </div>
        <div className="total-row grand">
          <span className="total-label">Grand Total</span>
          <span className="total-val" style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 28, color: 'var(--gold)' }}>
            {fmt(grandTotal)}
          </span>
        </div>
      </div>
    </div>
  );
}
